import {CanDeactivateFn} from '@angular/router';
import {Observable} from 'rxjs';
import Swal from 'sweetalert2';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
  switchedToMobile?: boolean;
  hasUnsavedChanges?: boolean;
}

const confirmLeave = async (message: string): Promise<boolean> => {
  const res = await Swal.fire({
    title: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Leave',
    cancelButtonText: 'Stay',
    width: '35%',
    allowOutsideClick: false,
    allowEscapeKey: false
  });
  return !!res.value;
};

// A saved page leaves silently; an unsaved one asks first, and asks for the mobile version to be
// reviewed if it was never shown.
export const pageChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  const { hasUnsavedChanges, switchedToMobile } = component;

  // SAVED → allow silently regardless of mobile view
  if (!hasUnsavedChanges) {
    return true;
  }

  // UNSAVED + MOBILE NOT VIEWED
  if (!switchedToMobile) {
    return confirmLeave('You have unsaved changes. If you leave now, your changes will be lost. Before leaving, please review the mobile version.');
  }

  // UNSAVED + MOBILE VIEWED
  return confirmLeave('You have unsaved changes. If you leave now, your changes will be lost.');
};
